import type {
  Permission,
  PermissionAction,
  PermissionResourceKey,
} from '@/authorization/types';

interface PermissionEvaluationOptions {
  featureFlags?: Set<string>;
}

function hasRequiredFeature(
  permission: Permission,
  featureFlags: Set<string>,
): boolean {
  if (!permission.featureFlag) {
    return true;
  }

  return featureFlags.has(permission.featureFlag);
}

export function evaluatePermission(
  permissions: Permission[],
  resource: PermissionResourceKey,
  action: PermissionAction,
  options: PermissionEvaluationOptions = {},
): boolean {
  const featureFlags = options.featureFlags ?? new Set<string>();

  return permissions.some(
    (permission) =>
      permission.resource === resource &&
      permission.action === action &&
      permission.allowed &&
      hasRequiredFeature(permission, featureFlags),
  );
}

export function buildPermissionLookup(permissions: Permission[]) {
  return permissions.reduce<Record<string, Permission>>(
    (lookup, permission) => {
      const key = `${permission.resource}:${permission.action}`;
      lookup[key] = permission;
      return lookup;
    },
    {},
  );
}
